import YourStats from './YourStats';
export default YourStats;
